module.exports = require("./ug-CN");